import Form from "../form/Form";
import { edit } from '../../slices/advertisementSlice';
import { appUrl } from "../../utils/fetch";
import PropTypes from 'prop-types';
import { useNavigate } from "react-router-dom";

function Advertisement(props) {
    const { id, closeFunc } = props;
    const navigate = useNavigate();

    return (
        <Form 
            inputs={{
                type: {
                    label: "Placement of advertising",
                    field: "selectImage",
                    width: 6,
                    data: {
                        1: {
                            name: "Video Overlay Banner 300x250( left )",
                            src: "ad1.png"
                        },
                        2: {
                            name: "Video Overlay Banner 300x250( right )",
                            src: "ad2.png"
                        },
                        3: {
                            name: "Native Thumbnail Ad",
                            src: "ad3.png"
                        },
                        4: {
                            name: "Sidebar Video / Detail Banner 300 x 250 ",
                            src: "ad4.png"
                        },
                        5: {
                            name: "VAST Video Ad",
                            src: "ad5.png"
                        },
                        6: {
                            name: "Footer Banner 300x250",
                            src: "ad6.png"
                        },
                        7: {
                            name: "Mobile banner",
                            src: "ad7.png"
                        },
                    },
                    merged: {
                    }
                },
                name: {
                    field: "text",
                    label: "Name",
                    width: 6,
                    merged: {
                            source: {
                                field: "textarea",
                                label: "Advertisement source code"
                            },
                            status: {
                                label: "Status",
                                field: "buttonswitch",
                                data: [
                                    { id: 1, label: "Active", color: "green" },
                                    { id: 2, label: "Inactive", color: "red" },
                                ],
                                sx: {
                                    paddingBottom: "10px",
                                    borderBottom: "1px solid rgba(170, 187, 204, .5)",
                                    marginBottom: "10px",
                                }
                            },
                            device: {
                                label: "Appearance",
                                field: "buttonswitch",
                                multiple: true,
                                disabledConditions: [
                                    {
                                        stateName: "advertisement",
                                        valueName: "type",
                                        value: [4, 5, 7]
                                    }
                                ],
                                data: [
                                    { id: 1, label: "Desktop" },
                                    { id: 2, label: "Mobile" }
                                ]
                            },
                            categories: {
                                label: "Categories",
                                field: "multiselect",
                                data: "content-categories-search",
                                extraFuncType: "addNew",
                                extraFuncName: "categories",
                                extraFuncLabel: "New category"
                            },
                            scheduled_from: {
                                label: "Active since",
                                field: "date",
                                time: true,
                                sx: {
                                    width: "calc((100% - 10px) / 2)",
                                    display: "inline-block"
                                }
                            },   
                            scheduled_to: {
                                label: "Active until",
                                field: "date",
                                time: true,
                                sx: {
                                    width: "calc((100% - 10px) / 2)",
                                    display: "inline-block",
                                    marginLeft: "10px"
                                }
                            },   
                            empty: {
                                field: "empty",
                                height: 40
                            } 
                        }
                    }
                }
            }
            columns={2}
            stateName="advertisement"
            dispatchFunc={edit}
            title={id !== "new" ? "Edit Ad" : "Create Ad"}
            api={`${appUrl}/api/ad`}
            navbar
            doneFunc={() => { if(closeFunc){closeFunc()} else {navigate(`/advertisement/list/page/1`)} }}
            detailId={id}
            required={[ "name" ]}
            validation={[ "notNull" ]}
        />
    );
}

export default Advertisement;

Advertisement.propTypes = {
    id: PropTypes.number
};